<div class="loader none">
  <img src="../assets/images/spinner.gif" />
</div>
<div class="wrapper">
  <div class="mobile-overlay" onclick="toggleMobileOverlay()"></div>
  <app-header [ngClass]="{ hide: !showHeader }" *ngIf="!isLogin && !isResetPassword"></app-header>
  <app-sidenav [ngClass]="{ hide: !showSideNav }"></app-sidenav>
</div>
<main [ngClass]="showSideNav ? 'main-content clearfix' : ''">
  <div [ngClass]="showSideNav ? 'container-fluid' : ''">
    <router-outlet></router-outlet>
  </div>
  <button id="success" class="btn btn-success hide"></button>
  <button id="danger" class="btn btn-danger hide"></button>
  <button id="warning" class="btn btn-warning hide"></button>
</main>
